
<b-field class="field-body" grouped>
	<b-input
		v-if="
			isEditMode &&
			(type === 'text' ||
				type === 'email' ||
				type === 'password' ||
				type === 'textarea' ||
				type === 'url')
		"
		:required="required"
		:disabled="disabled"
		expanded
		:placeholder="placeholder"
		:type="type"
		:value="value"
		autocomplete="off"
		@input="$emit('input', $event)"
	/>
	<b-input
		v-if="isEditMode && type === 'currency'"
		step="0.01"
		min="0"
		:required="required"
		:disabled="disabled"
		expanded
		:placeholder="placeholder"
		type="number"
		:value="value"
		autocomplete="off"
		@input="handleNumberInput"
	/>
	<b-input
		v-if="isEditMode && type === 'number'"
		step="1"
		min="1"
		:required="required"
		:disabled="disabled"
		expanded
		:placeholder="placeholder"
		type="number"
		:value="value"
		autocomplete="off"
		@input="handleNumberInput"
	/>
	<b-checkbox
		v-if="isEditMode && type === 'checkbox'"
		:value="checked"
		:disabled="disabled"
		@input="$emit('input', $event)"
	/>
	<b-switch
		v-if="isEditMode && type === 'switch'"
		:value="checked"
		:disabled="disabled"
		@input="$emit('input', $event)"
	></b-switch>

	<span
		v-if="
			!isEditMode &&
			(type === 'text' || type === 'email' || type === 'password' || type === 'textarea')
		"
		v-html="value ? value : '-'"
		class="pre"
	></span>
	<span v-if="!isEditMode && type === 'number'" v-html="value ? value : '0'"></span>
	<span
		v-if="!isEditMode && type === 'currency'"
		v-html="value ? `${value} ${currency} ${paymentVat ? paymentVat + ' ' : ''}` : '-'"
	></span>
	<a
		v-if="!isEditMode && type === 'url' && value"
		:href="value"
		target="_blank"
		rel="noopener noreferrer"
		>{{ value }}</a
	>
	<span v-if="!isEditMode && type === 'link' && !value">-</span>
	<span
		v-if="!isEditMode && (type === 'checkbox' || type === 'switch')"
		v-html="checked ? 'tak' : 'nie'"
	></span>
</b-field>
